import axios from '@/libs/api.request'

const Api = {
  Order: '/trade/order',
  Coupon: '/trade/coupon',
  Pay: '/trade/pay',
  Resend: '/trade/resend',
  TradeStat: '/trade/stat',
  TradeList: '/trade/list',
  TradeDetail: '/trade/detail/',
  CommissionList: '/member/commissions',
  CommissionApply: '/member/commission/apply'
}

export const addTicket = (data) => {
  return axios.request({
    url: Api.Order,
    data: data,
    method: 'post'
  })
}

export const checkCoupon = (data) => {
  return axios.request({
    url: Api.Coupon,
    data: data,
    method: 'post'
  })
}

// 重新发送支付邮件
export const reSend = (data) => {
  return axios.request({
    url: Api.Resend,
    data: data,
    method: 'post'
  })
}

// 支付订单
export const pay = (data) => {
  return axios.request({
    url: Api.Pay,
    data: data,
    method: 'post'
  })
}

// 订单列表
export const getTradeList = (data) => {
  return axios.request({
    url: Api.TradeList,
    data: data,
    method: 'post'
  })
}

// 订单
export const getTrade = (data) => {
  return axios.request({
    url: Api.TradeDetail + data.trade_id,
    method: 'get'
  })
}

export const getStat = () => {
  return axios.request({
    url: Api.TradeStat,
    method: 'get'
  })
}

export const getCommissionList = (data) => {
  return axios.request({
    url: Api.CommissionList,
    data: data,
    method: 'post'
  })
}

export const applyCommission = (data) => {
  return axios.request({
    url: Api.CommissionApply,
    data: data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/trade.js